export default "__VITE_ASSET__b2Zoag_k__"